module.exports = __webpack_public_path__ + "static/media/placeholder.fa1c49c8.svg";